import React from 'react';
import cn from 'classnames';

import styles from './problem-card.module.scss';

interface IProps {
  className: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
}

const ProblemCard: React.FC<IProps> = (props) => {
  const { className, icon: Icon, text } = props;

  return (
    <div className={cn(styles.card, className)}>
      <Icon className={styles.card__icon} />
      <p className={styles.card__text}>{text}</p>
    </div>
  );
};

export default ProblemCard;
